enum GameState {
    Playing, Success, Failure
}

export default GameState;
